import { GetApp } from "@mui/icons-material";

export const baseUrl = process.env.REACT_APP_API_URL;
// export const baseUrl = process.env.REACT_APP_API_URL;
export const Url = {
  //Student Post method
  StudentLogin: baseUrl + "FASTAPI/student/login",
  StudentLogout: baseUrl + "FASTAPI/logout",
  AdminLogout: baseUrl + "FASTAPI/user/logout",
  StudentInformation: baseUrl + "FASTAPI/get_student_data",
  OverAllSimulationProgressReport: (simulationCode) =>
    baseUrl +
    `FASTAPI/over_all_simulation_progress_report?simulation_code=${simulationCode}`,
    SimulationComplete: (simCode) => baseUrl + `FASTAPI/simulation_complete/${simCode}`,
  GetStudentDetails: (group_code) =>
    baseUrl + `FASTAPI/get_student_credentials/${group_code}`,
  AdminStudentLogin: baseUrl + "FASTAPI/student/login/from/admin",
  DownloadReportGet: (groupId) =>
    baseUrl + `FASTAPI/all_module_download_report?group_id=${groupId}`,
  FinishStatusPost: baseUrl + "FASTAPI/finish_status",
  FinishStatusGet: (group_code) =>
    baseUrl + `FASTAPI/get_finish_status?group_code=${group_code}`,

  DeleteExcel: baseUrl + "FASTAPI/delete_excel",
  //  display racking units
  DisplayRackingUnits: (groupId) =>
    baseUrl + `FASTAPI/subdisplay-racking-unit/total/${groupId}`,

  // display board and signage

  DisplayBoard: (groupId) =>
    baseUrl + `FASTAPI/get_sum_of_total_display_board?group_id=${groupId}`,

  // commercial eqipment

  CommercialEquipment: (groupId) =>
    baseUrl + `FASTAPI/get_sum_of_total2?group_id=${groupId}`,
  //  info tech
  DisplayInfoTech: (groupId) =>
    baseUrl + `FASTAPI/get_sum_of_total_info_tech?group_id=${groupId}`,

  // Plumbing
  DisplayPlumbing: (groupId) =>
    baseUrl + `FASTAPI/get_sum_of_total_plumbing?group_id=${groupId}`,

  // visual merchandising
  DisplayVisualMerchElements: (groupId) =>
    baseUrl +
    `FASTAPI/get_sum_of_total_visual_merch_elements?group_id=${groupId}`,

  // Carpentary and furniture

  CarpentaryandFurniture: (groupId) =>
    baseUrl + `FASTAPI/get_sum_of_total1?group_id=${groupId}`,

  // Landing page
  PostLandingPageData: baseUrl + `FASTAPI/create_landing_page`,

  progressreportpost: (groupId, simulationCode) =>
    baseUrl +
    `FASTAPI/progress_report_final?group_id=${groupId}&simulation_code=${simulationCode}`,

  // Superadmin Api
  AddAdmin: baseUrl + "FASTAPI/superadmin/institution",
  Get_All_Admin: baseUrl + "FASTAPI/superadmin_get_all_admin",
  Get_Individual_Admin: (admin_Id) =>
    baseUrl + `FASTAPI/get_admin_institution?user_id=${admin_Id}`,
  Upload_Groups_and_Student_Details: baseUrl + "FASTAPI/upload-students-excel",
  GetAdminQueries: baseUrl + `FASTAPI/get_support_query`,
  Post_SolveAdminQuery: baseUrl + `FASTAPI/create_support_query_response`,
  GetSuperAdminDetails: baseUrl + `FASTAPI/get_super_admin_details`,
  DownloadCategory: baseUrl + `FASTAPI/catchment_download_category_excel`,
  UploadCategory: baseUrl + `FASTAPI/upload-main-data`,
  GetCategoryData: baseUrl + "FASTAPI/get_category_in_main_data",
  PostStartandEndDate: baseUrl + "FASTAPI/create_start_and_end_date",

  //Admin Api
  AdminLogin: baseUrl + "FASTAPI/user/login",
  ForgetPassword: baseUrl + "FASTAPI/forgot-password",
  ResetPassword: baseUrl + "FASTAPI/reset-password",
  NewPassword: baseUrl + "FASTAPI/new-password",
  createSimulation: baseUrl + "FASTAPI/superadmin/simulation",
  Run_Sumulation: (simulation_Id) =>
    baseUrl + `FASTAPI/run_simulation?simulation_id=${simulation_Id}`,
  GetSimulationGroupStudent: (sim_code) =>
    baseUrl + `FASTAPI/simulation/${sim_code}/groups`,

  Get_Simulation_Group_Student: (groupId) =>
    baseUrl + `FASTAPI/get_groups_by_group_code_student?group_id=${groupId}`,
  Get_Download_Excel: (simCode) =>
    `${baseUrl}FASTAPI/download_excel_end?simulation_code=${simCode}`,

  CurrentSimulation: baseUrl + "FASTAPI/simulation",

  GetAdminCategory: baseUrl + "FASTAPI/get_master",
  CreateAdminCategory: baseUrl + "FASTAPI/create_master",
  Get_Admin: baseUrl + "FASTAPI/get_admin",
  // Edit_Simulation_EndDate: (simId, endDate) =>
  //   baseUrl +
  //   `FASTAPI/update_end_date?simulation_id=${simId}&end_date=${endDate}`,
  Get_Student_Details: baseUrl + `FASTAPI/get_simulation_group`,
  Put_Student_Details: baseUrl + `FASTAPI/update_student_mail`,
  Get_Student_Fail_Mail: (groupCode) =>
    baseUrl + `FASTAPI/send_mail_in_error_mails?group_code=${groupCode}`,
  Send_email_to_Student: (groupCode) =>
    baseUrl + `FASTAPI/send_group_mail?group_code=${groupCode}`,
  GetAdminDetails: baseUrl + "FASTAPI/get_query_user_details",
  PostAdminQuery: baseUrl + "FASTAPI/create_support_query_request",
  GetRemainingMembersCount: baseUrl + `FASTAPI/get_two_field_data`,
  GetGmailDetails: (groupCode) =>
    baseUrl + `FASTAPI/get_admin_student_email?group_code=${groupCode}`,
  PostSendEmail: baseUrl + `FASTAPI/send_mail`,
  PostCategory: baseUrl + `FASTAPI/create_category_id`,

  // Student Forgot Password
  StudentForgetPassword: baseUrl + "FASTAPI/student_otp_send",
  StudentResetPassword: baseUrl + "FASTAPI/otp_validation",
  StudentNewPassword: baseUrl + "FASTAPI/change_password",

  // student Submission Deadline
  submissionDeadlineGet: (simId) =>
    baseUrl + `FASTAPI/get_start_end_date?group_id=${simId}`,
  // Active Simulations

  submissionGet: (groupId) =>
    baseUrl + `FASTAPI/get_start_end_date?group_id=${groupId}`,

  // cost section total cost

  getCapitalTotal: (groupId) =>
    baseUrl + `FASTAPI/get_sum_of_estimate_cost?group_id=${groupId}`,

  //   utilities total cost
  Utilitiestotalget: (groupId) =>
    baseUrl + `FASTAPI/get_total_cost?group_id=${groupId}`,

  ActiveSimulation: baseUrl + `FASTAPI/simulation`,
  get_simulationGroups: (simulation_id, simulation_code) =>
    baseUrl +
    `FASTAPI/simulation/${simulation_id}/groups?simulation_code=${simulation_code}`,
  get_Group_Student: (group_Code) =>
    baseUrl + `FASTAPI/get_simulation_group_student/${group_Code}`,

  // Choose category selection

  GetCategory: (groupId) => baseUrl + `FASTAPI/group/category/${groupId}`,
  ChooseCategoryname: baseUrl + "FASTAPI/category",

  // Module 1
  // Brand Information
  IntroductionDataPost: baseUrl + `FASTAPI/created_introduction`,
  UpdateIntroEdit: baseUrl + `FASTAPI/update_introduction`,
  GetIntroductionData: (groupId) =>
    baseUrl + `FASTAPI/get_introduction/${groupId}`,

  BrandinformationPost: baseUrl + "FASTAPI/brand",
  BrandinformationGet: (groupId) =>
    baseUrl + `FASTAPI/brands/by-group/${groupId}`,
  BrandinformationPut: (id) => baseUrl + `FASTAPI/brand/${id}`,
  BrandinformationDelete: (brandId) =>
    baseUrl + `FASTAPI/brand/delete?brand_id=${brandId}`,
  BrandImageDelete: (brandId) => `${baseUrl}brand/${brandId}/image`,

  OnlineYesNoPost: baseUrl + `FASTAPI/yes_no_create`,
  OnlineYesNoGet: (groupId) =>
    baseUrl + `FASTAPI/get_yes_no?group_id=${groupId}`,
  OnlineYesNoPut: baseUrl + `FASTAPI/update_yes_no`,

  // marketing plan total

  TotalMarketingPlanGet: (groupId) =>
    baseUrl + `FASTAPI/get_integarted_marketing_total/${groupId}`,

  // Segment frorm
  SegmentPost: baseUrl + "FASTAPI/segment",
  SegmentGet: (groupId) => baseUrl + `FASTAPI/segment/${groupId}`,
  SegmentPut: baseUrl + "FASTAPI/segment/update",
  SegmentDelete: (segmentId) =>
    baseUrl + `FASTAPI/segment/delete?segment_id=${segmentId}`,
  Isecvalueget: (groupId) => baseUrl + `FASTAPI/get_one_field/${groupId}`,
  StoreFormatGet: (groupId) => baseUrl + `FASTAPI/store-formate/${groupId}`,
  StoreFormatPost: baseUrl + `FASTAPI/store-formates`,
  StoreFormatPut: baseUrl + `FASTAPI/store-formate/update`,
  StoreFormatDelete: (storeId) =>
    baseUrl + `FASTAPI/store-formate/delete/${storeId}`,
  StoreFormatimageDelete: (storeId) =>
    baseUrl + `FASTAPI/store_formate_delete_image?store_id=${storeId}`,
  CapitalExpensesPost: baseUrl + "FASTAPI/civil",
  CapitalExpensesGet: (groupId) => baseUrl + `FASTAPI/civil/${groupId}`,
  CapitalExpensesPut: baseUrl + "FASTAPI/update_civil",
  CapitalExpensesDelete: (civilId) =>
    baseUrl + `FASTAPI/delete_civil?civil_id=${civilId}`,
  CapitalExpensesSubtotal: (groupId) => baseUrl + `FASTAPI/subtotal/${groupId}`,

  // Display and Racking unit
  ReackingUnitPost: baseUrl + "FASTAPI/display-racking-unit",
  ReackingUnitGet: (groupId) =>
    baseUrl + `FASTAPI/display-racking-unit/${groupId}`,
  ReackingUnitPut: baseUrl + "FASTAPI/update_display_racking",
  ReackingUnitDelete: (rackId) =>
    baseUrl + `FASTAPI/delete_display_racking?rack_id=${rackId}`,

  ElectricalCablingPost: baseUrl + "FASTAPI/create_electrical_cabling",
  ElectricalCablingGet: (groupId) =>
    baseUrl + `FASTAPI/get_electrical_cabling/${groupId}`,
  ElectricalCablingPut: baseUrl + "FASTAPI/update_electrical_cabling",
  ElectricalCablingDelete: (electricalId) =>
    baseUrl + `FASTAPI/delete_electrical_cabling?electrical_id=${electricalId}`,

  ElectricalCablingSubTotalGet: (groupId) =>
    baseUrl + `FASTAPI/get_sum_electrical_cabling?group_id=${groupId}`,

  DisplayBoardSignagePost: baseUrl + "FASTAPI/display_board",
  DisplayBoardSignageGet: (groupId) =>
    baseUrl + `FASTAPI/get_display_board/${groupId}`,
  DisplayBoardSignagePut: baseUrl + "FASTAPI/update_display_board",
  DisplayBoardSignageDelete: (displayBoardId) =>
    baseUrl +
    `FASTAPI/delete_display_board?display_board_delete_id=${displayBoardId}`,
  //

  //  Information Technology & Hardware
  InformationTechnologyHardwarePost: baseUrl + "FASTAPI/info_tech",
  InformationTechnologyHardwareGet: (groupId) =>
    baseUrl + `FASTAPI/get_info_tech/${groupId}`,
  InformationTechnologyHardwarePut: baseUrl + "FASTAPI/update_info_tech",
  InformationTechnologyHardwareDelete: (infotechId) =>
    baseUrl + `FASTAPI/delete_info_tech?info_tech_delete_id=${infotechId}`,
  tech_store_formatGet: (groupId) =>
    baseUrl + `FASTAPI/tech_store_format?group_id=${groupId}`,
  // Defining Location

  LocationDetailsPost: baseUrl + "FASTAPI/created_location_details",
  LocationDetailsGet: (groupId) =>
    baseUrl + `FASTAPI/get_location_details${groupId}`,

  // Visual Merchandising

  VisualMerchandisingPost: baseUrl + "FASTAPI/visual_merchandising_elements",
  VisualMerchandisingGet: (groupId) =>
    baseUrl + `FASTAPI/get_group_visual_merch_elements?group_id=${groupId}`,
  VisualMerchandisingPut: baseUrl + "FASTAPI/update_visual_merch_elements",
  VisualMerchandisingDelete: (visualId) =>
    baseUrl +
    `FASTAPI/delete_visual_merch_elements?visual_delete_id=${visualId}`,

  VisualMerchandisingStrategyPost:
    baseUrl + "FASTAPI/create_visual_merch_Strategy",
  VisualMerchandisingStrategyGet: (groupId) =>
    baseUrl + `FASTAPI/get_visual_merch_Strategy?group_id=${groupId}`,
  VisualMerchandisingStrategyPut:
    baseUrl + "FASTAPI/update_visual_merch_Strategy",

  // PLUMPING
  PlumbingPost: baseUrl + "FASTAPI/Plumbing_creat",
  PlumbingEdit: baseUrl + "FASTAPI/update_plumbing",
  PlumbingGet: (groupId) => baseUrl + `FASTAPI/Plumbing_creat/${groupId}`,
  deletePlumbing: (plumb_id) =>
    baseUrl + `FASTAPI/delete_plumbing?plumb_id=${plumb_id}`,

  // Commercial Equipment
  CommercialEquipmentPost: baseUrl + "FASTAPI/commercial_equipment_create",
  CommercialEquipmentGet: (groupId) =>
    baseUrl +
    `FASTAPI/commercial_equipment_response/${groupId}/total_potential`,
  CommercialEquipmentPut: baseUrl + "FASTAPI/update_commercial_equipment",
  CommercialEquipmentDelete: (equipmentId) =>
    baseUrl + `FASTAPI/delete_commercial_equipment?equipment_id=${equipmentId}`,

  // //  Carpentry and Furniture
  FurnitureandCarpentryGet: (groupId) =>
    baseUrl + `FASTAPI/get_carpentry?group_id=${groupId}`,
  FurnitureandCarpentryPost: baseUrl + "FASTAPI/carpentry",
  FurnitureandCarpentryPut: baseUrl + "FASTAPI/update_carpentry",
  FurnitureandCarpentryDelete: (carpentryId) =>
    baseUrl + `FASTAPI/delete_carpentry?carpentry_id=${carpentryId}`,
  // Addtional

  AdditionalInstallationPost:
    baseUrl + "FASTAPI/create_additional_installation",
  AdditionalInstallationPut: baseUrl + "FASTAPI/update_additional_installation",
  DeleteAddInstallation: (additonalId) =>
    baseUrl +
    `FASTAPI/delete_additional_installation?additional_id=${additonalId}`,
  // AdditionalInstallationGet: (groupId) =>
  //   baseUrl + `FASTAPI/get_group_additional_installation1/${groupId}`,
  AdditionalInstallationGet: (groupId) =>
    baseUrl + `FASTAPI/get_group_additional_installation/${groupId}`,

  DepreciationPost: baseUrl + "FASTAPI/depreciation",
  DepreciationPut: baseUrl + `FASTAPI/update_depreciation`,
  DepreciationDelete: (depreciation_delete_id) =>
    baseUrl +
    `FASTAPI/delete_depreciation?depreciation_delete_id=${depreciation_delete_id}`,

  DepreciationGet: (groupId) =>
    baseUrl + `FASTAPI/get_group_depreciation${groupId}`,

  ModuleOneDownloadReportGet: (groupId) =>
    baseUrl + `FASTAPI/${groupId}/download1`,
  ModuleOneDownloadPreviewGet: (groupId) =>
    baseUrl + `FASTAPI/${groupId}/preview-report-pdf1`,
  CapitalExpensesSummaryGet: (groupId) =>
    baseUrl + `FASTAPI/get_capital_expenses/${groupId}`,
  // baseUrl + `FASTAPI/${groupId}/preview-report-pdf1`,

  // Module Location Analysis

  // Customer Location
  // ISECvalueGet: (groupId) => baseUrl + `FASTAPI/get_one_field/${groupId}`,
  isecValueGet: (groupId) => `${baseUrl}FASTAPI/get_one_field/${groupId}`,
  customerlocationPost: baseUrl + "FASTAPI/customer_location",
  customerlocationGet: (groupId) =>
    baseUrl + `FASTAPI/customer_location/group/${groupId}`,
  customerlocationPut: baseUrl + "FASTAPI/customer_location/update",
  customerlocationDelete: (customerLocationId) =>
    baseUrl + `FASTAPI/customer_location/delete/${customerLocationId}`,
  TotalConsumption: (groupId) =>
    baseUrl + `FASTAPI/customer_location/group/${groupId}/total_consumption`,

  CatchmentPotentialPost: baseUrl + "FASTAPI/catchment_creat",
  CatchmentPotentialGet: (groupId) => baseUrl + `FASTAPI/catchment/${groupId}`,
  CatchmentTotalPotentialGet: (groupId) =>
    baseUrl + `FASTAPI/catchment_potential/${groupId}/total_potential`,
  CatchmentPotentialPut: baseUrl + "FASTAPI/catchment/update",
  CatchmentPotentialDelete: (catchId) =>
    baseUrl + `FASTAPI/catchment/delete/${catchId}`,

  AnnexuresPost: baseUrl + "FASTAPI/create_annexures",
  AnnexuresGet: (groupId) => baseUrl + `FASTAPI/get_annexures/${groupId}`,
  AnnexuresPut: baseUrl + "FASTAPI/update_annexures",
  AnnexuresDelete: (annexuresId) =>
    baseUrl + `FASTAPI/delete_annexures?annexures_id=${annexuresId}`,

  // image upload setCompetitionData
  CreateCompetitorIntensity: baseUrl + "FASTAPI/create_competitor_intensity",
  UpdateCompetitorIntensity: baseUrl + "FASTAPI/update_competitor_intensity",
  CompetitorIntensityDelete: (competitor_id) =>
    baseUrl + `FASTAPI/delete_competitor_image1?competitor_id=${competitor_id}`,
  // CompetitionDataPost: baseUrl + "FASTAPI/create_competitor_intensity",
  CompetitionDataGet: (groupId) =>
    baseUrl + `FASTAPI/get_group_competitor_intensity/${groupId}`,

  LocationSpillageFactorPost: baseUrl + "FASTAPI/create_location_spillage",
  LocationSpillageFactorGet: (groupId) =>
    baseUrl + `FASTAPI/get_location_spillage/${groupId}`,

  LocationSpillageFactorPut: baseUrl + "FASTAPI/update_location_spillage",
  LocationSpillageFactorDelete: (locationId) =>
    baseUrl + `FASTAPI/delete_location_spillage?location_id=${locationId}`,

  // defining location
  DefiningLocationPost: baseUrl + "FASTAPI/created_location_details",
  DefiningLocationGet: (groupId) =>
    baseUrl + `FASTAPI/get_location_details/${groupId}`,

  DefiningLocationPut: baseUrl + "FASTAPI/update_location_details",
  DefiningLocationDelete: (detailsId) =>
    baseUrl + `FASTAPI/delete_location_details?details_id=${detailsId}`,

  //Market Share
  MarketSharePost: baseUrl + `FASTAPI/created_projected_marker_share`,
  MarketShareEdit: baseUrl + `FASTAPI/update_projected_marker_share`,
  MarketShareGet: (groupId) =>
    baseUrl + `FASTAPI/get_projected_marker_share${groupId}`,

  get_sales_calculations: (groupId) =>
    baseUrl + `FASTAPI/get_sales_calculations/${groupId}`,

  // ---------- Pricing Strategy Section ---------

  // Competitor Pricing Analysis
  postCompetitorPricingAnalysis:
    baseUrl + "FASTAPI/create_competitor_pricing_analysis",
  getGroupCompetitorPricingAnalysis: (groupId) =>
    baseUrl +
    `FASTAPI/get_group_competitor_pricing_analysis?group_id=${groupId}`,
  editCompetitorPricingAnalysis:
    baseUrl + "FASTAPI/update_competitor_pricing_analysis",

  // Store Format Pricing Strategies
  postcreateStoreFormate: baseUrl + "FASTAPI/create_store_formate",
  editStoreFormate: baseUrl + "FASTAPI/update_store_formate",
  getGroupStoreFormatePricing: (groupId) =>
    baseUrl + `FASTAPI/get_group_store_formate_pricing_strategies${groupId}`,

  // Category Pricing Strategies

  postCategoryPricingStrategis:
    baseUrl + "FASTAPI/create_category_pricing_strategis",
  editCategoryPricingStrategis:
    baseUrl + "FASTAPI/update_category_pricing_strategis",
  getCategoryPricingStrategis: (groupId) =>
    baseUrl + `FASTAPI/get_category_pricing_strategis/${groupId}`,
  deleteCategoryPricingStrategis: (category_id) =>
    baseUrl +
    `FASTAPI/delete_category_pricing_strategis?category_id=${category_id}`,

  // Customer Engagement Strategies

  getCustomerEngagementStrategies: (categoryId) =>
    baseUrl + `FASTAPI/get_customer_engagement/${categoryId}`,
  postCustomerEngagement: baseUrl + "FASTAPI/create_customer_engagement",
  editCustomerEngagement: baseUrl + "FASTAPI/update_customer_engagement",

  // Competitor Loyalty Program Observations

  getCompetitorLoyaltyProgram: (categoryId) =>
    baseUrl + `FASTAPI/get_competitor_loyalty/${categoryId}`,
  postCompetitorLoyaltyProgram: baseUrl + "FASTAPI/create_competitor_loyalty",
  editCompetitorLoyaltyProgram: baseUrl + "FASTAPI/update_competitor_loyalty",

  // Define Your Promotions

  postCreateDefineYourPromotions:
    baseUrl + "FASTAPI/create_define_your_promotions",
  editDefineYourPromotions: baseUrl + "FASTAPI/update_define_your_promotions",
  getDefineYourPromotions: (groupId) =>
    baseUrl + `FASTAPI/get_define_your_promotions/${groupId}`,

  // Promotion Competitor Analysis

  postPromotionCompetitorAnalysis:
    baseUrl + "FASTAPI/create_promotion_competitor_analysis",
  editPromotionCompetitorAnalysis:
    baseUrl + "FASTAPI/update_promotion_competitor_analysis",
  getPromotionCompetitorAnalysis: (groupId) =>
    baseUrl +
    `FASTAPI/get_promotion_competitor_analysis/${groupId}?grouup_id=${groupId}`,

  // Recovery of Promotional
  postRecoveryPromotional: baseUrl + "FASTAPI/create_recovery_of_promotional",
  editRecoveryPromotional: baseUrl + "FASTAPI/update_recovery_of_promotional",
  getRecoveryPromotional: (groupId) =>
    baseUrl + `FASTAPI/get_recovery_of_promotional/${groupId}`,

  // Categories Under Promotions
  postCategoriesUnderPromotions:
    baseUrl + "FASTAPI/create_categories_under_promotions",
  editCategoriesUnderPromotions:
    baseUrl + "FASTAPI/update_categories_under_promotions",
  getCategoriesUnderPromotions: (groupId) =>
    baseUrl + `FASTAPI/get_categories_under_promotions/${groupId}`,

  // Competitor Bench Marking
  CompetitorBenchMarkingPost: baseUrl + `FASTAPI/competitor_bench_marking`,
  CompetitorBenchMarkingput:
    baseUrl + `FASTAPI/update_competitor_bench_marking`,
  CompetitorBenchMarkingGet: (groupId) =>
    baseUrl + `FASTAPI/get_competitor_bench_marking${groupId}`,

  //Sales and Expenses
  SalesValuePost: baseUrl + `FASTAPI/create_sales_estimate`,
  SalesValueGet: (groupId) =>
    baseUrl + `FASTAPI/get_group_sales_estimate?group_id=${groupId}`,
  SalesValuePut: baseUrl + "FASTAPI/update_sales_estimate",
  SalesValueDelete: (salesId) =>
    baseUrl + `FASTAPI/delete_sales_estimate?sales_id=${salesId}`,

  RentExpensesPost: baseUrl + `FASTAPI/create_rent_expenses`,
  RentGroupExpensesGet: (groupId) =>
    baseUrl + `FASTAPI/get_group_rent_expenses?group_id=${groupId}`,
  RentGroupExpensesPut: baseUrl + "FASTAPI/update_rent_expenses",
  RentGroupExpensesDelete: (rentId) =>
    baseUrl + `FASTAPI/delete_rent_expenses?rent_id=${rentId}`,

  PreviewFormatTwoGet: (groupId) =>
    baseUrl + `FASTAPI/${groupId}/preview-report-pdf2`,
  DownloadReportTwoGet: (groupId) => baseUrl + `FASTAPI/${groupId}/download2`,

  // Primary Research Category Management (FIXED)
  PrimaryResearchPost: baseUrl + "FASTAPI/create_competitor_category_analyses",
  PrimaryResearchGet: (groupId) =>
    baseUrl + `FASTAPI/get_group_competitor_category_analyses${groupId}`,
  PrimaryResearchPut: baseUrl + `FASTAPI/update_competitor_category_analyses`,

  // Excel
  // CustomerLocation
  DownloadExcelSample: baseUrl + "FASTAPI/download_excel_file_sample1",
  DownloadExcelSampleThreePost: baseUrl + "FASTAPI/upload-excel-sample1",
  GetCustomerLocationExcel: (groupId) =>
    baseUrl + `FASTAPI/get_excel_url/${groupId}`,

  // CompetitionIntensity
  DownloadExcelSamplePost: baseUrl + "FASTAPI/upload-excel-sample2",
  DownloadExcelSampleTwo: baseUrl + "FASTAPI/download_excel_file_sample2",

  // CategoryManagement
  CategoryDownloadExcel: baseUrl + "FASTAPI/download_excel_pre1",
  CategoryUploadExcel: baseUrl + "FASTAPI/upload_retails1",
  // CategoryUploadExcel: baseUrl + "FASTAPI/upload_excel123",

  // Training & Talent Management
  TrainingManagementDownloadExcel:
    baseUrl + "FASTAPI/download_excel_category_definition",
  TrainingManagementUploadExcel:
    baseUrl + "FASTAPI/upload_excel_category_definition",

  // Online Policies
  OnlinePoliciesExcelGet: baseUrl + "FASTAPI/download_online_policies_excel1",
  OnlinePoliciesExcelPost: baseUrl + "FASTAPI/upload_online_policies_excel",

  // Shrinkage in Retail – Areas & Reasons
  InventoryExcelget: baseUrl + "FASTAPI/download_inventory_excel1",
  InventoryExcelpost: baseUrl + "FASTAPI/upload_inventory_excel",

  DownloadExcelSampleTwoPost: baseUrl + "FASTAPI/upload-excel-sample2",
  // Category management
  DownloadExcelSampleThree: baseUrl + "FASTAPI/download_excel_pre",

  createGrossMarginContribution:
    baseUrl + "FASTAPI/create_gross_margin_contribution",
  CategoryManagementStoreformatAandBGet: (groupId) =>
    baseUrl + `FASTAPI/Pre_get?group_id=${groupId}`,
  // UploadHistoryget: (groupId) =>
  //   baseUrl + `FASTAPI/Pre_get_excel_history/${groupId}`,
  UploadHistoryget: (groupCode) =>
    baseUrl + `FASTAPI/excel_history/${groupCode}`,

  getAllCategoryName: (groupId) =>
    baseUrl + `FASTAPI/sync_allcontent/${groupId}`,
  getGroupGrossMargin: (groupId) =>
    baseUrl + `FASTAPI/get_group_gross_margin_contribution?group_id=${groupId}`,
  getCategoryInsights: (groupId) =>
    baseUrl + `FASTAPI/get_margin_and_sales_contribution_analysis/${groupId}`,
  createCategoryInsights:
    baseUrl + "FASTAPI/create_margin_and_sales_contribution_analysis",
  updateCategoryInsights:
    baseUrl + "FASTAPI/update_margin_and_sales_contribution_analysis",
  delete_gross_margin_contribution: (grossId) =>
    baseUrl + `FASTAPI/delete_gross_margin_contribution?gross_id=${grossId}`,
  updateGrossMarginContribution:
    baseUrl + "FASTAPI/update_gross_margin_contribution",
  Category_Management_Post: baseUrl + `FASTAPI/created_category_management`,
  Category_Management_Get: (groupId) =>
    baseUrl + `FASTAPI/geted_category_management?group_id=${groupId}`,
  Category_Management_Put: baseUrl + `FASTAPI/updated_category_management`,
  Category_Management_Delete: (catId) =>
    baseUrl + `FASTAPI/deleted_category_management?delete_id=${catId}`,
  Category_Name: (groupId) =>
    baseUrl + `FASTAPI/geted_category_name?group_id=${groupId}`,
  All_Content_Category_Name: (groupId) =>
    baseUrl + `FASTAPI/geted_allcontent/${groupId}`,

  // M - 4 S -4

  DragDropContextPost: baseUrl + "FASTAPI/create_all_content",
  DragDropContextGet: (groupId) =>
    baseUrl + `FASTAPI/get_all_content/${groupId}`,
  DragDropContextPut: baseUrl + "FASTAPI/update_all_content",
  DragDropContextDelete: (allId) =>
    baseUrl + `FASTAPI/delete_all_content?all_id=${allId}`,

  // Network Planning
  // NetworkPlanningPost: baseUrl + "FASTAPI/create_network_plan",
  NetworkPlanningGet: (groupId) =>
    baseUrl + `FASTAPI/create_network_plan/${groupId}/total_network`,
  postNetworkPlan: baseUrl + "FASTAPI/create_network_plan",
  editNetworkPlan: baseUrl + "FASTAPI/update_network_plan",
  deleteNetworkPlan: (network_id) =>
    baseUrl + `FASTAPI/delete_network_plan?network_id=${network_id}`,
  totalNetworkGet: (groupId) =>
    baseUrl + `FASTAPI/get_network_plan_total/${groupId}`,

  // Trading Months
  TradingMonthsPost: baseUrl + "FASTAPI/trading",
  TradingMonthsEdit: baseUrl + "FASTAPI/update_trading",
  TradingMonthsGet: (groupId) =>
    baseUrl + `FASTAPI/trading-responce/${groupId}`,

  // Pre-Operating Expenses
  PreOperatingExpensesPost: baseUrl + "FASTAPI/pre_operating_expense",
  PreOperatingExpensesEdit: baseUrl + "FASTAPI/update_pre_operating_expenses",
  PreOperatingExpensesGet: (groupId) =>
    baseUrl + `FASTAPI/pre_operating_expense-responce/${groupId}`,

  StoreInvestmentSummaryget: (groupId) =>
    baseUrl + `FASTAPI/get_store_investment_summary/${groupId}`,
  // Summary section download reports

  BrandInformationGet: (groupId) =>
    baseUrl + `FASTAPI/brands/by-group_id/${groupId}`,
  deleteBrandinformation: (brand_id) =>
    baseUrl + `FASTAPI/brand/delete?brand_id=${brand_id}`,

  VendorMetricsPriorityListGet: (groupId) =>
    baseUrl +
    `FASTAPI/get_group_id_vendor_metrics_priority_list?group_id=${groupId}`,
  //VendorManagement

  VendorScoreboardGet: (groupId) =>
    baseUrl + `FASTAPI/get_group_vendore_scorecard?group_id=${groupId}`,

  VendorScoreboardPut: baseUrl + `FASTAPI/update_vendor_scorecard`,

  VendorMetricsPriorityListPost:
    baseUrl + `FASTAPI/create_vendor_metrics_priority_list`,

  VendorScoreboardsPost: baseUrl + `FASTAPI/create_vendor_scorecard`,

  VendorMetricsPriorityListDelete: (vendor_Id) =>
    baseUrl +
    `FASTAPI/delete_vendor_metrics_priority_list?vendor_id=${vendor_Id}`,

  VendorMetricsPriorityListPut:
    baseUrl + `FASTAPI/update_vendor_metrics_priority_list`,

  VendorScoreboardsEdit: baseUrl + `FASTAPI/update_vendor_scorecard`,

  // private lebelling
  GetPrivateLabelCount: (groupId) =>
    baseUrl + `FASTAPI/get_category_values/${groupId}`,

  // VendorPrivateLabllingPost: baseUrl + `FASTAPI/create_private_lablling`,

  VendorPrivateLabllingGet: (groupId) =>
    baseUrl + `FASTAPI/get_group_private_lablling?group_id=${groupId}`,
  VendorPrivateLabllingDelete: (private_Id) =>
    baseUrl + `FASTAPI/delete_private_lablling?private_id=${private_Id}`,
  VendorPrivateLabllingCategoryNamePut:
    baseUrl + `FASTAPI/update_private_lablling`,
  VendorPrivateLabllingprivateid: (private_get_id) =>
    baseUrl + `FASTAPI/get_private_lablling?private_get_id=${private_get_id}`,
  VendorPrivateLabllingPost:
    baseUrl + `FASTAPI/create_category_captinship_planning`,
  categoryCaptainshipPlanningput:
    baseUrl + `FASTAPI/update_category_captinship_planning`,
  PostVendorPrivateLablling: baseUrl + `FASTAPI/create_private_lablling`,
  VendorCategoryCaptainshipPlanningGet: (groupId) =>
    baseUrl +
    `FASTAPI/get_group_category_captinship_planning?group_id=${groupId}`,
  VendorCategoryCaptainshipPlanningDelete: (categoryPlanId) =>
    baseUrl +
    `FASTAPI/delete_category_captinship_planning?category_plan_id=${categoryPlanId}`,

  // VendorCategoryCaptainshipPlanningDelete:(groupId)=>
  // baseUrl + `FASTAPI/delete_category_captinship_planning?group_id=${groupId}`,
  VendorPrivateLabllingCategoryName: (groupId) =>
    baseUrl + `FASTAPI/geted_category_name?group_id=${groupId}`,
  CategoryCaptainshipGetExcel: (groupId) =>
    baseUrl + `FASTAPI/geted_category_name?group_id=${groupId}`,
  VendorPrivateLabllingCategoryNameDelete: (private_id) =>
    baseUrl + `FASTAPI/delete_private_lablling?private_id=${private_id}`,
  SalesPromotiongetexcel: (groupId) =>
    baseUrl + `FASTAPI/geted_category_name?group_id=${groupId}`,

  //  sales and expenses

  GetSalesEstimationTotal: (groupId) =>
    baseUrl + `FASTAPI/get_sales_multiple_total?group_id=${groupId}`,

  GetTotalEstimateValue: (groupId) =>
    baseUrl + `FASTAPI/get_total_estimated/${groupId}`,

  // Marketting Communications

  BrandAttributeAssessmentandCustomerPerceptionPost:
    baseUrl + `FASTAPI/create_brand_attribute_assessment`,

  BrandAttributeAssessmentandCustomerPerceptionGet: (groupId) =>
    baseUrl + `FASTAPI/get_brand_attribute_assessment/${groupId}`,
  onlinegetattribute: (groupId) =>
    baseUrl + `FASTAPI/get_brand_attribute/${groupId}`,

  BrandAttributeAssessmentandCustomerPerceptionPut:
    baseUrl + `FASTAPI/update_brand_attribute_assessment`,
  BrandAttributeAssessmentandCustomerPerceptiondelete: (groupId) =>
    baseUrl + `FASTAPI/delete_attribute?group_id=${groupId}`,

  AttributesPost: baseUrl + `FASTAPI/create_branding_attributes`,

  AttributesGet: (groupId) =>
    baseUrl + `FASTAPI/get_branding_attributes/${groupId}`,

  AttributesDelete: baseUrl + `FASTAPI/clear_column`,

  AttributesPut: baseUrl + `FASTAPI/update_branding_attributes`,

  //Marketing

  MarketingandCommunicationBudgetAllocationPost:
    baseUrl + `FASTAPI/created_integrated_marketing`,

  MarketingandCommunicationBudgetAllocationGet: (groupId) =>
    baseUrl + `FASTAPI/get_integrated_marketing/${groupId}`,

  MarketingandCommunicationBudgetAllocationPut:
    baseUrl + `FASTAPI/update_integrated_marketing`,

  MarketingandCommunicationBudgetAllocationDelete: (integrated_id) =>
    baseUrl +
    `FASTAPI/delete_integrated_marketing?integrated_id=${integrated_id}`,

  MarketingandCommunicationBudgetAllocationTwoFieldGet: (groupId) =>
    baseUrl + `FASTAPI/get_2_fields/${groupId}`,

  //CompetitorAnalysis

  CompetitorAnalysispost: baseUrl + `FASTAPI/create_marketing_competitor`,

  CompetitorAnalysisGet: (groupId) =>
    baseUrl + `FASTAPI/get_marketing_competitor${groupId}`,

  CompetitorAnalysisPut: baseUrl + `FASTAPI/update_marketing_competitor`,

  //Optimising Assets

  OptimisingAssetsPost: baseUrl + `FASTAPI/create_optimising_assets`,

  OptimisingAssetsGet: (groupId) =>
    baseUrl + `FASTAPI/get_optimising_assets/${groupId}`,

  OptimisingAssetsPut: baseUrl + `FASTAPI/update_optimising_assets`,

  OptimisingAssetsDelete: (optimising_id) =>
    baseUrl + `FASTAPI/delete_optimising_assets?optimising_id=${optimising_id}`,

  //Vendor Management
  VendorMetricsPriorityPost:
    baseUrl + "FASTAPI/create_vendor_metrics_priority_list",
  NegotiationStrategyforDamageandExpiryPost:
    baseUrl + `FASTAPI/create_short_negotiation_final`,

  NegotiationStrategyforDamageandExpiryGet: (groupId) =>
    baseUrl + `FASTAPI/get_short_negotiation_final/${groupId}`,

  NegotiationStrategyforDamageandExpiryPut:
    baseUrl + `FASTAPI/update_short_negotiation_final`,

  //  supply chain :

  // Supply Chain URLs
  SupplyChainPost: baseUrl + "FASTAPI/create_centralised_and_direct",
  SupplyChainGet: (groupId) =>
    baseUrl + `FASTAPI/get_centralised_and_direct/${groupId}`,
  SupplyChainPut: baseUrl + "FASTAPI/update_centralised_and_direct",

  // adopting
  // create_adapting_supply_chaine:
  //   baseUrl + "FASTAPI/create_adapting_supply_chaine",
  // get_adapting_supply_chaine: (groupId) =>
  //   baseUrl + `FASTAPI/get_adapting_supply_chaine/${groupId}`,
  // update_adapting_supply_chaine:
  //   baseUrl + "FASTAPI/update_adapting_supply_chaine",

  // Adapting Supply Chain URLs
  create_adapting_supply_chaine:
    baseUrl + "FASTAPI/create_adapting_supply_chaine",
  getadaptingsupplychaine: (groupId) =>
    baseUrl + `FASTAPI/get_adapting_supply_chaine${groupId}`,
  updateadaptingsupplychaine: baseUrl + "FASTAPI/update_adapting_supply_chaine",

  // Group and Category
  CategoryWishInventoryGet: (groupId) =>
    baseUrl + `FASTAPI/get_group_id${groupId}`,
  GetCategoryName: (groupId) =>
    baseUrl + `FASTAPI/get_category_name?group_id=${groupId}`,

  // Inventory APIs
  CategoryWiseInventorypost: baseUrl + "FASTAPI/create_category_wish_inventory",
  CreateShrinkageAreasReasonspost:
    baseUrl + "FASTAPI/create_shrinkage_areas_reasons",
  UpdateShrinkageAreasReasonsput:
    baseUrl + "FASTAPI/update_shrinkage_areas_reasons",
  GetShrinkageAreasReasons: (groupId) =>
    baseUrl + `FASTAPI/get_shrinkage_areas_reasons${groupId}`,
  UpdateCategoryWiseInventoryput:
    baseUrl + "FASTAPI/update_category_wish_inventory",
  // CategoryWiseInventoryDelete: (categoryWishId) =>
  //   baseUrl +
  //   `FASTAPI/delete_category_wish_inventory?category_Wish_Id=${categoryWishId}`,

  // CategoryWiseInventorypost: baseUrl + "FASTAPI/create_category_wish_inventory",
  //  CreateShrinkageAreasReasonspost: baseUrl + "FASTAPI/create_shrinkage_areas_reasons",
  // UpdateShrinkageAreasReasonsput: baseUrl + "FASTAPI/update_shrinkage_areas_reasons",
  // GetShrinkageAreasReasons: (groupId) => baseUrl + `FASTAPI/get_shrinkage_areas_reasons${groupId}`,
  // CategoryWiseInventorypost: baseUrl + "FASTAPI/create_category_wish_inventory1/",
  // UpdateCategoryWiseInventoryput: baseUrl + "FASTAPI/update_category_wish_inventory/",

  // CategoryWiseInventoryDelete: (categoryWishId) =>
  //   baseUrl + `FASTAPI/delete_category_wish_inventory?category_Wish_Id=${categoryWishId}`,

  // cash conversion cycle table api

  CashConversionCyclePost:
    baseUrl + `FASTAPI/create_cash_conversion_cycle_router`,
  CashConversionCycleGet: (groupId) =>
    baseUrl + `FASTAPI/get_cash_conversion_cycle_router?group_id=${groupId}`,
  CashConversionCyclePut:
    baseUrl + `FASTAPI/update_cash_conversion_cycle_router`,

  // Margin and Sales Data
  GetMarginSales: (groupId) => baseUrl + `FASTAPI/get_margin_sales${groupId}`,

  CategorywiseInventoryGet: (categoryWishId) =>
    baseUrl + `FASTAPI/delete_category_wish_inventory${categoryWishId}`,

  CategoryWiseInventoryDelete: (categoryWishId) =>
    baseUrl +
    `FASTAPI/delete_category_wish_inventory?category_wish_id=${categoryWishId}`,

  // Services & Utilities

  OrganisationalChartPost:
    baseUrl + "FASTAPI/upload_corporate_and_concept_level_organizational_chart",
  OrganisationalChartGet: (groupId) =>
    baseUrl + `FASTAPI/get_image_corporate?group_id=${groupId}`,
  OrganisationalChartDelete: (groupId) =>
    baseUrl + `FASTAPI/delete_image_corporate1?group_id=${groupId}`,

  CorporateOfficePost: baseUrl + "FASTAPI/create_corporate_concept_office",
  CorporateOfficeGet: (groupId) =>
    baseUrl + `FASTAPI/get_corporate_concept_office/${groupId}`,
  CorporateOfficePut: baseUrl + `FASTAPI/update_corporate_concept_office`,
  CorporateOfficeDelete: (corporateId) =>
    baseUrl +
    `FASTAPI/delete_corporate_concept_office?corporate_id=${corporateId}`,

  ConceptOfficePost: baseUrl + "FASTAPI/create_concept_office",
  ConceptOfficeGet: (groupId) =>
    baseUrl + `FASTAPI/get_concept_office/${groupId}`,
  ConceptOfficePut: baseUrl + "FASTAPI/update_concept_office",
  ConceptOfficeDelete: (conceptId) =>
    baseUrl + `FASTAPI/delete_concept_office?concept_id=${conceptId}`,

  // Store Level Services

  storelevelorganizationchartPost:
    baseUrl + "FASTAPI/upload_store_level_organization_chart",
  storelevelorganizationchartGet: (groupId) =>
    baseUrl + `FASTAPI/get_image_store_level?group_id=${groupId}`,
  storelevelorganizationchartDelete: (groupId) =>
    baseUrl + `FASTAPI/delete_image_tore_level1?group_id=${groupId}`,

  // Section Get Api Show only
  PreSelectedServiceGet: (groupId) =>
    baseUrl + `FASTAPI/get_pre_selected_service?group_id=${groupId}`,

  StoreLevelServicesPost: baseUrl + "FASTAPI/create_store_level_staff",
  StoreLevelServicesGet: (groupId) =>
    baseUrl + `FASTAPI/get_store_level_staff${groupId}`,
  StoreLevelServicesPut: baseUrl + "FASTAPI/update_store_level_staff",
  StoreLevelServicesDelete: (storeId) =>
    baseUrl + `FASTAPI/delete_store_level_staff?store_id=${storeId}`,

  // Training & Talent Management

  CompetitorAnalysisComparisonPost:
    baseUrl + "FASTAPI/create_competitor_analysis_comparison",
  CompetitorAnalysisComparisonGet: (groupId) =>
    baseUrl + `FASTAPI/get_group_competitor_analysis_comparison${groupId}`,

  CompetitorAnalysisComparisonPut:
    baseUrl + `FASTAPI/update_competitor_analysis_comparison`,
  CompetitorAnalysisComparisonDelete: (competitorId) =>
    `FASTAPI/delete_competitor_analysis_comparison?competitor_id=${competitorId}`,

  //  Training Talent Management Excel

  TrainingTalentManagementExcelGet: baseUrl + "FASTAPI/download_excel",
  TrainingTalentManagementExcelPost: baseUrl + "FASTAPI/upload_excel",

  // Utilities

  UtilitiesPost: baseUrl + "FASTAPI/create_utility",
  UtilitiesGet: (groupId) => baseUrl + `FASTAPI/get_utility${groupId}`,
  UtilitiesPut: baseUrl + "FASTAPI/update_utility",
  UtilitiesDelete: (utilityId) =>
    baseUrl + `FASTAPI/delete_utility?utility_id=${utilityId}`,

  OperatingExpensesPost: baseUrl + "FASTAPI/create_operating_expense",

  OperatingExpensesGet: (groupId) =>
    baseUrl + `FASTAPI/get_operating_expenses${groupId}`,
  OperatingExpensesDelete: (recurringId) =>
    baseUrl + `FASTAPI/delete_operating_expenses/${recurringId}`,
  OperatingExpensesPut: baseUrl + "FASTAPI/update_operating_expenses",

  //Module 10 Api

  // Online Distribution

  ComparativeAnalysisPost: baseUrl + "FASTAPI/create_comparative_analysis",
  ComparativeAnalysisGet: (groupId) =>
    baseUrl + `FASTAPI/get_comparative_analysis/${groupId}`,
  ComparativeAnalysisPut: baseUrl + "FASTAPI/update_comparative_analysis",
  ComparativeAnalysisOnlineStoreGet: baseUrl + `FASTAPI/get_own_brand_data`,
  ComparativeAnalysisDelete: (comparativeId) =>
    baseUrl +
    `FASTAPI/delete_comparative_analysis?comparative_id=${comparativeId}`,

  OnlinePreSelectedServicePost:
    baseUrl + "FASTAPI/create_online_pre_select_service",
  OnlinePreSelectedServiceGet: (groupId) =>
    baseUrl + `FASTAPI/get_online_pre_select_service${groupId}`,
  OnlinePreSelectedServicePut:
    baseUrl + "FASTAPI/update_online_pre_select_service",

  //Backend chain_Sales
  SalesPost: baseUrl + "FASTAPI/create_sales",
  SalesGet: (groupId) => baseUrl + `FASTAPI/get_sales${groupId}`,
  DigitalAssetsPost: baseUrl + `FASTAPI/create_digital_asset`,
  DigitalAssetsGet: (groupId) =>
    baseUrl + `FASTAPI/get_digital_asset${groupId}`,
  DigitalAssetsPut: baseUrl + "FASTAPI/update_digital_asset",
  DigitalAssetsDelete: (digitalId) =>
    baseUrl + `FASTAPI/delete_digital_asset?digital_id${digitalId}`,
  DigitalAssetsTotalGet: (groupId) =>
    baseUrl + `FASTAPI/get_digital_asset_total?group_id=${groupId}`,
  SalesPut: baseUrl + "FASTAPI/update_sales",
  SalesTotalValueGet: (salesId) =>
    baseUrl + `FASTAPI/get_multiple_sales?get_id=${salesId}`,

  // Digital Asset
  DigitalAssetPost: baseUrl + "FASTAPI/create_digital_asset",
  DigitalAssetGet: (groupId) => baseUrl + `FASTAPI/get_digital_asset${groupId}`,
  DigitalAssetPut: baseUrl + "FASTAPI/update_digital_asset",
  DigitalAssetDelete: (digitalId) =>
    baseUrl + `FASTAPI/delete_digital_asset?digital_id=${digitalId}`,
  DigitalAssetTotalValuesGet: baseUrl + "FASTAPI/get_sum_of_estimate_cost",
  //Recurring Operating

  RecurringOperatingPost: baseUrl + "FASTAPI/create_recurring_operating",
  // RecurringOperatingGet: baseUrl + "FASTAPI/get_recurring_operating",
  RecurringOperatingGet: (groupId) =>
    baseUrl + `FASTAPI/get_recurring_operating${groupId}`,
  RecurringOperatingPut: baseUrl + "FASTAPI/update_recurring_operating",
  RecurringOperatingDelete: (recurringId) =>
    baseUrl + `FASTAPI/delete_recurring_operatind?recurring_id=${recurringId}`,

  //Assessments Section

  AssessmentsPost: baseUrl + "FASTAPI/create_critical_for_business",
  AssessmentsGet: (groupId) =>
    baseUrl + `FASTAPI/get_critical_for_business${groupId}`,
  AssessmentsPut: baseUrl + "FASTAPI/update_critical_for_business",
  AssessmentsDelete: (criticalId) =>
    baseUrl + `FASTAPI/delete_critical_for_business?critical_id=${criticalId}`,

  PersonalisedEvaluationPost:
    baseUrl + "FASTAPI/create_expanded_performance_metrics",
  PersonalisedEvaluationGet: (groupId) =>
    baseUrl + `FASTAPI/get_expanded_performance_metrics${groupId}`,
  PersonalisedEvaluationPut:
    baseUrl + "FASTAPI/update_expanded_performance_metrics",
  PersonalisedEvaluationDelete: (expandedId) =>
    baseUrl +
    `FASTAPI/delete_expanded_performance_metrics?expanded_id=${expandedId}`,

  MeasuringSalesProfitabilityPost:
    baseUrl + "FASTAPI/create_measuring_sales_profitability",
  MeasuringSalesProfitabilityGet: (groupId) =>
    baseUrl + `FASTAPI/get_measuring_sales_profitability/${groupId}`,
  MeasuringSalesProfitabilityPut:
    baseUrl + "FASTAPI/update_measuring_sales_profitability",

  // Summary

  CreateSummaryPost: baseUrl + "FASTAPI/create_summary",
  UpdateSummaryEdit: baseUrl + "FASTAPI/update_summary  ",
  GetSummaryData: (groupId) => baseUrl + `FASTAPI/get_summary/${groupId}`,

  // pre selcted service api

  getPreSelectedServices: (groupId) =>
    baseUrl + `FASTAPI/get_pre_selected_service?group_id=${groupId}`,

  // overview api
  OverviewGet: (simulationId) =>
    baseUrl + `FASTAPI/module10/overview?simulation_id=${simulationId}`,
  //  OverviewGet: (simulationId) =>
  //   `${baseUrl}FASTAPI/module10/overview?simulation_id=${simulationId}`,
  YearlyIncreasepost: (groupId) => baseUrl + `FASTAPI/module10/calculate`,

  //  Module 3 reports and preview

  Module3ReportGet: (groupId) =>
    baseUrl + `FASTAPI/${groupId}/preview-report-pdf3`,
  ModuleThreeDownloadReportGet: (groupId) =>
    baseUrl + `FASTAPI/${groupId}/download3`,

  // category management report and preview 4
  CategoryManagementReportGet: (groupId) =>
    baseUrl + `FASTAPI/download4/${groupId}`,
  CategoryManagementPreviewGet: (groupId) =>
    baseUrl + `FASTAPI/${groupId}/preview-report-pdf4`,

  // vendor management report and preview module 5

  VendorManagementReportGet: (groupId) =>
    baseUrl + `FASTAPI/download5/${groupId}`,
  VendorManagementPreviewGet: (groupId) =>
    baseUrl + `FASTAPI/${groupId}/preview-report-pdf5`,

  // promotion report and preview module 6

  PromotionReportGet: (groupId) => baseUrl + `FASTAPI/${groupId}/download6`,

  PromotionPreviewGet: (groupId) =>
    baseUrl + `FASTAPI/${groupId}/preview-report-pdf6`,

  // google calender

  PromotionCalenderPost: baseUrl + "FASTAPI/create_promotion_calender",
  PromotionCalenderGet: (groupId) =>
    baseUrl + `FASTAPI/get_promotion_calender/${groupId}`,
  PromotionCalenderPut: baseUrl + "FASTAPI/update_promotion_calender",
  PromotionCalenderDelete: (promotionId) =>
    baseUrl + `FASTAPI/delete_promotion_calender?promotion_id=${promotionId}`,

  // Marketing communications report and preview module 7

  MarketingCommunicationsPreviewGet: (groupId) =>
    baseUrl + `FASTAPI/${groupId}/preview-report-pdf7`,
  MarketingCommunicationsReportGet: (groupId) =>
    baseUrl + `FASTAPI/${groupId}/download7`,

  // backend supply chain report and preview module 9
  SupplyChainReportGet: (groupId) => baseUrl + `FASTAPI/download9/${groupId}`,
  SupplyChainPreviewGet: (groupId) =>
    baseUrl + `FASTAPI/${groupId}/preview-report-pdf9`,

  // module service and utilities

  ServicesAndUtilitiesReportGet: (groupId) =>
    baseUrl + `FASTAPI/${groupId}/download8`,
  ServicesAndUtilitiesPreviewGet: (groupId) =>
    baseUrl + `FASTAPI/${groupId}/preview-report-pdf8`,

  // metric and performance index report and preview module 10
  MetricAndPerformanceIndexReportGet: (groupId) =>
    baseUrl + `FASTAPI/download10/${groupId}`,
  MetricAndPerformanceIndexPreviewGet: (groupId) =>
    baseUrl + `FASTAPI/preview-report-pdf10/${groupId}`,

  // yearly Increase physical store format
  YearlyIncreasephysicalstoreformatGet: (groupId) =>
    baseUrl + `FASTAPI/get_physical_store_formats/${groupId}`,
  postYearlyIncreasePhysicalStoreFormat:
    baseUrl + `FASTAPI/create_physical_store_formats`,
  putYearlyIncreasePhysicalStoreFormat:
    baseUrl + `FASTAPI/update_physical_store_formats`,

  // yearly increase Cap-Ex Refurbish

  YearlyIncreaseGet: (groupId) =>
    baseUrl + `FASTAPI/get_cap_ex_refurbish/${groupId}`,
  postYearlyIncrease: baseUrl + `FASTAPI/create_cap_ex_refurbish`,
  putYearlyIncrease: baseUrl + `FASTAPI/update_cap_ex_refurbish`,

  // yearly increase online store

  YearlyIncreaseOnlineStoreGet: (groupId) =>
    baseUrl + `FASTAPI/get_online_store_format/${groupId}`,
  postYearlyIncreaseOnlineStore: baseUrl + `FASTAPI/create_online_store_format`,
  putYearlyIncreaseOnlineStore: baseUrl + `FASTAPI/update_online_store_format`,

  // category selection

  categoryselectionGet: (groupId) =>
    baseUrl + `FASTAPI/groupbased/${groupId}/main-data`,
  selectionget: (simulationId) =>
    baseUrl + `FASTAPI/geted_simulation_category?simulation_id=${simulationId}`,

  comparativedelete: (comparativeId) =>
    baseUrl +
    `FASTAPI/delete_comparative_analysis?comparative_Id=${comparativeId}`,

  //Overview
  Y1OverviewGet: (groupId) =>
    baseUrl + `FASTAPI/overview-y1?group_id=${groupId}`,

  Y5OverviewGet: (groupId) =>
    baseUrl + `FASTAPI/overview-y5?group_id=${groupId}`,
  CustomerMetricsGet: (groupId) =>
    baseUrl + `FASTAPI/get_con_fact/${groupId}`,

  Y12OverviewGet: (groupId) =>
    baseUrl + `FASTAPI/overview-y12?group_id=${groupId}`,

  ProfitLossGet: (groupCode) => baseUrl + `FASTAPI/profit-loss/${groupCode}`,
  BalanceCashFlowGet: (groupCode) =>
    baseUrl + `FASTAPI/balance-sheet-report/${groupCode}`,
};
